import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('CONFETTI_CANNON', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const gravity = config.collisionEffectGravity || 0.5;
  for (let i = 0; i < 30; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = -Math.PI / 2 + (rnd - 0.5) * Math.PI;
    const speed = 10 + rnd * 10;
    const t = elapsed / 16.6;
    const x = e.pos.x + Math.cos(angle) * speed * t;
    const y = e.pos.y + Math.sin(angle) * speed * t + 0.5 * gravity * t * t;

    if (config.rgbLighting && config.useFXRGB) {
      ctx.fillStyle = `hsl(${(rnd * 360)}, 100%, 50%)`;
    } else {
      ctx.fillStyle = e.color;
    }
    ctx.globalAlpha = 1 - progress;
    ctx.save(); ctx.translate(x, y); ctx.rotate(t * rnd);
    ctx.fillRect(-3, -2, 6, 4);
    ctx.restore();
  }
});
